<template>
  <div>
    <div class="overlay"></div>
    <div class="image-light-box">
          <span class="image-light-box--icon" @click="close()">
            <svg-icon type="icon-close"/>
          </span>
      <transition name="fade">
        <div class="image-light-box--inner" v-if="show">
          <img :src="data.image" alt="">
        </div>
      </transition>
      <div class="navigator" style="width: 34%;">
        <button class="navigator__left" @click="left()">
          <span class="icon">
            <svg-icon type="icon-arrow-long-left"/>
          </span>
        </button>
        <button class="navigator__right" @click="right()">
          <span class="icon">
            <svg-icon type="icon-arrow-long-right"/>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImageLightBox',

  data () {
    return {
      show: true,
      showLightbox: true,
      transitionName: 'lightbox-slide-fade-left'
    }
  },

  props: {
    data: Object,
    currentIndex: Number
  },
  methods: {
    close () {
      this.$emit('closeLightBox')
    },

    right () {
      this.$emit('onClickNext')
      this.show = false
      this.transitionName = 'lightbox-slide-fade-left'
      setTimeout(() => {
        this.show = true
      }, 300)
    },

    left () {
      this.$emit('onClickPrev')
      this.show = false
      this.transitionName = 'lightbox-slide-fade-right'
      setTimeout(() => {
        this.show = true
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/scss/components/image-light-box";

  .image-light-box--inner {
    position: relative;
    width: 25%;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */
  {
    opacity: 0;
  }

  .lightbox-slide-fade-left-enter-active {
    transition: all .35s ease-in-out;
  }

  .lightbox-slide-fade-left-leave-active {
    transition: all .35s ease-in-out;
  }

  .lightbox-slide-fade-left-enter {
    transform: translateX(10%);
    opacity: 0;
    pointer-events: none;
  }

  .lightbox-slide-fade-left-leave-to {
    transform: translateX(-100%);
    opacity: 0;
    pointer-events: none;
  }

  //slide fade right

  .lightbox-slide-fade-right-enter-active {
    transition: all .35s ease-in-out;
  }

  .lightbox-slide-fade-right-leave-active {
    transition: all .35s ease-in-out;
  }

  .lightbox-slide-fade-right-enter {
    transform: translateX(-100%);
    opacity: 0;
    pointer-events: none;
  }

  .lightbox-slide-fade-right-leave-to {
    transform: translateX(100%);
    opacity: 0;
    pointer-events: none;
  }
</style>
